module.exports = __webpack_public_path__ + "img/hbxhgzc_position_img.ca5a19a7.png";